// extracted by mini-css-extract-plugin
module.exports = {"header":"Confirm_header__R0cBU","description":"Confirm_description__3w8mK","counter":"Confirm_counter__OQ8bG","resend":"Confirm_resend__RNNdQ"};